import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const FREQUENTLY_ASKED_QUESTIONS_FREQUENTLY_ASKED_QUESTION_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/frequently-asked-questions',
        iconClass: 'fas fa-question',
        name: '::Menu:FrequentlyAskedQuestions',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.FrequentlyAskedQuestions.Create && ReturnLy.FrequentlyAskedQuestions.Edit && ReturnLy.FrequentlyAskedQuestions.Delete',
        parentName: '::Menu:Configurations',
      },
    ]);
  };
}
